// extracted by mini-css-extract-plugin
export default {"companyContainer":"QM-z","companyImage":"RM-z","container":"SM-z","heading":"TM-z","darkText":"UM-z","smallHeading":"VM-z","darkBackground":"WM-z","whiteBackground":"XM-z"};